import _slicedToArray from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "blogArticleData", "pageRoute", "siteName"];
var __jsx = React.createElement;
/**
 * Represents BlogArticle.
 * @author kkum
 */import React from 'react';
import styled from 'styled-components';
import Heading from '../../atoms/Heading';
import Image from '../../atoms/Image';
import RichText from '../../atoms/RichText/RichText';
import styles from './BlogArticle.style';
import { imageRenditions } from './config';
import Para from '../../atoms/Para';
import ThreeTile from '../ThreeTile';
import { useRouter } from 'next/router';
import urlSlug from 'url-slug';
import SocialIcons from '../../molecules/SocialIcons';
var BlogArticleDetails = function BlogArticleDetails(_ref) {
  var _blogContent$links, _blogContent$links$en, _blogContent$links2, _blogContent$links2$e, _blogContent$links3, _blogContent$links3$a, _relatedBlogs$tileCol, _relatedBlogs$tileCol2, _relatedBlogs$tileCol3;
  var className = _ref.className,
    blogArticleData = _ref.blogArticleData,
    pageRoute = _ref.pageRoute,
    siteName = _ref.siteName,
    others = _objectWithoutProperties(_ref, _excluded);
  if (!blogArticleData) {
    return null;
  }
  var title = blogArticleData.title,
    blogCategory = blogArticleData.blogCategory,
    blogImage = blogArticleData.blogImage,
    blogContent = blogArticleData.blogContent,
    webpageBlog = blogArticleData.webpageBlog,
    blogAuthor = blogArticleData.blogAuthor,
    blogDate = blogArticleData.blogDate,
    shareLinks = blogArticleData.shareLinks,
    relatedBlogs = blogArticleData.relatedBlogs;
  var imageSource = blogImage && blogImage.image && blogImage.image.url;
  var content = blogContent && blogContent.json;
  var richTextEmbeddedAsset = blogContent.links && blogContent.links.assets.block || [];
  var _useRouter = useRouter(),
    query = _useRouter.query;
  var author = blogAuthor ? "By ".concat(blogAuthor) : '';
  var dateFormatted = blogDate !== null ? __jsx(React.Fragment, null, __jsx("span", {
    className: "nva-blog-article__date"
  }, new Date(blogDate).toLocaleString('en', {
    timeZone: "GMT",
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })), __jsx("span", null, " \xB7 ")) : '';
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hasMounted = _React$useState2[0],
    setHasMounted = _React$useState2[1];
  React.useEffect(function () {
    setHasMounted(true);
  }, []);
  return __jsx("div", {
    className: "nva-blog-article ".concat(className)
  }, __jsx("div", {
    className: "nva-blog-article__container container"
  }, __jsx("div", {
    className: "nva-blog-article__header"
  }, __jsx(Heading, {
    HeadingType: "h1",
    className: "nva-blog-article__title"
  }, title), __jsx(Heading, {
    HeadingType: "h4",
    className: "nva-blog-article__category"
  }, dateFormatted, __jsx("span", {
    className: "nva-blog-article__category-label"
  }, blogCategory.categoryName)), __jsx(Para, {
    className: "nva-blog-article__author u-body2"
  }, author)), __jsx("div", {
    className: "nva-blog-article__image image-wrapper"
  }, __jsx(Image, {
    alt: blogImage.altText,
    title: blogImage.title || blogImage.altText,
    src: imageSource,
    srcSetSettingImg: {
      imageRenditions: imageRenditions
    }
  })), __jsx(RichText, {
    jsonContent: blogContent === null || blogContent === void 0 ? void 0 : blogContent.json,
    entriesContent: blogContent === null || blogContent === void 0 ? void 0 : (_blogContent$links = blogContent.links) === null || _blogContent$links === void 0 ? void 0 : (_blogContent$links$en = _blogContent$links.entries) === null || _blogContent$links$en === void 0 ? void 0 : _blogContent$links$en.block,
    linksContent: blogContent === null || blogContent === void 0 ? void 0 : (_blogContent$links2 = blogContent.links) === null || _blogContent$links2 === void 0 ? void 0 : (_blogContent$links2$e = _blogContent$links2.entries) === null || _blogContent$links2$e === void 0 ? void 0 : _blogContent$links2$e.inline,
    richTextEmbeddedAsset: blogContent === null || blogContent === void 0 ? void 0 : (_blogContent$links3 = blogContent.links) === null || _blogContent$links3 === void 0 ? void 0 : (_blogContent$links3$a = _blogContent$links3.assets) === null || _blogContent$links3$a === void 0 ? void 0 : _blogContent$links3$a.block,
    className: "nva-blog-article__content blog-content"
  }), shareLinks && __jsx("div", {
    className: "nva-blog-article__share"
  }, __jsx("span", {
    className: "nva-blog-article__share-label u-h4 max-sm:u-mb-3"
  }, "Share this post"), __jsx(SocialIcons, {
    className: "nva-blog-article__share-icons",
    socialIconsData: shareLinks,
    locationName: siteName
  })), hasMounted && (relatedBlogs === null || relatedBlogs === void 0 ? void 0 : (_relatedBlogs$tileCol = relatedBlogs.tileCollection) === null || _relatedBlogs$tileCol === void 0 ? void 0 : (_relatedBlogs$tileCol2 = _relatedBlogs$tileCol.items) === null || _relatedBlogs$tileCol2 === void 0 ? void 0 : _relatedBlogs$tileCol2.length) > 0 && __jsx("div", {
    className: "nva-blog-article__related"
  }, __jsx(ThreeTile, {
    threeTileData: {
      variation: 'Variation-a',
      sectionHeadline: relatedBlogs === null || relatedBlogs === void 0 ? void 0 : relatedBlogs.sectionHeadline,
      tile: relatedBlogs === null || relatedBlogs === void 0 ? void 0 : (_relatedBlogs$tileCol3 = relatedBlogs.tileCollection) === null || _relatedBlogs$tileCol3 === void 0 ? void 0 : _relatedBlogs$tileCol3.items.map(function (itemTile) {
        var _itemTile$sys, _itemTile$tileCta;
        return {
          sys: {
            id: itemTile === null || itemTile === void 0 ? void 0 : (_itemTile$sys = itemTile.sys) === null || _itemTile$sys === void 0 ? void 0 : _itemTile$sys.id
          },
          tileHeadline: itemTile === null || itemTile === void 0 ? void 0 : itemTile.tileHeadline,
          categoryTitle: itemTile === null || itemTile === void 0 ? void 0 : itemTile.categoryTitle,
          tileText: itemTile === null || itemTile === void 0 ? void 0 : itemTile.tileText,
          tileImage: itemTile === null || itemTile === void 0 ? void 0 : itemTile.tileImage,
          tileURL: itemTile === null || itemTile === void 0 ? void 0 : (_itemTile$tileCta = itemTile.tileCta) === null || _itemTile$tileCta === void 0 ? void 0 : _itemTile$tileCta.url
        };
      })
    }
  }))));
};
BlogArticleDetails.defaultProps = {
  className: ''
};
export default styled(BlogArticleDetails).withConfig({
  componentId: "sc-1vyrxm2-0"
})(["", ";"], styles);